import { ICONS } from "Utils/icons";

/* Ex. DO NOT DELETE!!! */
// export const SINGLE_FEATURED_CARD_DATA = [
//   {
//     isMultiple: false,
//     type: "EVENT",
//     icon: ICONS.calendarToday(),
//     postedDate: "Posted March 28, 2026",
//     eventEndDate: "06-01-2026",
//     registrationEndDate: "05-28-2026",
//     registrationCloseInfo: "Registration Closes May 28th",
//     isRegistration: true,
//     title: "PSO Training Webinar",
//     desc: "Join us for training on data submission best practices and Common Format software implementation. This interactive webinar series will cover esssential topics for PSO members.",
//     additionalInfo:
//       <>
//         <div className="mb-4">
//           <span className="me-2">{ICONS.calendarToday()}</span> March 30 - April 1, 2026
//           <span className="ms-3 me-2">{ICONS.accessTime()}</span> 10:00 AM - 11:00 AM ET
//         </div>
//         <div className="">
//           <span className="me-2">{ICONS.locationOutlined()}</span> Online
//         </div>
//       </>,
//     additionalInfoMobile:
//       <>
//         <div className="mb-4">
//           <span className="me-2">{ICONS.calendarToday()}</span> March 30 - April 1, 2026
//         </div>
//         <div className="mb-4">
//           <span className="me-2">{ICONS.accessTime()}</span> 10:00 AM - 11:00 AM ET
//         </div>
//         <div className="mb-4">
//           <span className="me-2">{ICONS.locationOutlined()}</span> Online
//         </div>
//       </>
//   }
// ];

export const SINGLE_FEATURED_CARD_DATA = [];

/* Ex. DO NOT DELETE!!! */
// export const MULTI_FEATURED_CARD_DATA = [
//   [
//     {
//       isMultiple: true,
//       type: "EVENT",
//       icon: ICONS.calendarToday(),
//       postedDate: "Posted March 28, 2026",
//       eventEndDate: "06-01-2026",
//       registrationEndDate: "05-28-2026",
//       registrationCloseInfo: "Registration Closes May 28th",
//       isRegistration: true,
//       title: "PSO Training Webinar",
//       desc: "Join us for training on data submission best practices and Common Format software implementation. This interactive webinar series will cover esssential topics for PSO members.",
//       additionalInfo:
//         <>
//           <div className="mb-4">
//             <span className="me-2">{ICONS.calendarToday()}</span> April 30th, 2026
//             <span className="ms-3 me-2">{ICONS.accessTime()}</span> 10:00 AM - 11:00 AM ET
//           </div>
//           <div className="mb-4">
//             <span className="me-2">{ICONS.locationOutlined()}</span> Online
//           </div>
//         </>,
//       additionalInfoMobile:
//         <>
//           <div className="mb-4">
//             <span className="me-2">{ICONS.calendarToday()}</span> April 30th, 2026
//           </div>
//           <div className="mb-4">
//             <span className="me-2">{ICONS.accessTime()}</span> 10:00 AM - 11:00 AM ET
//           </div>
//           <div className="mb-4">
//             <span className="me-2">{ICONS.locationOutlined()}</span> Online
//           </div>
//         </>
//     },
//     {
//       isMultiple: true,
//       type: "ANNOUNCEMENT",
//       icon: ICONS.campaign(),
//       postedDate: "Posted March 15, 2026",
//       isRegistration: false,
//       title: "New Common Formats Updates Released",
//       desc: "Version 2.1 of the Hospital Common Format now available with advanced reporting capabilities and streamlined workflows. Download the updated specifications and implementation guides."
//     }],
// ]

export const MULTI_FEATURED_CARD_DATA = [
  [
    {
      isMultiple: true,
      type: "EVENT",
      icon: ICONS.calendarToday(),
      postedDate: "Posted MAY 28, 2026",
      eventEndDate: "06-25-2026",
      registrationEndDate: "06-25-2026",
      registrationCloseInfo: "Registration Closes June 25th",
      isRegistration: true,
      title: "Quarterly Call",
      desc: "A quarterly virtual convening hosted by AHRQ's PSO Division for federally listed Patient Safety Organizations. Sessions include program updates, new resource announcements, and patient safety initiatives relevant to PSO operations.",
      additionalInfo:
        <>
          <div className="mb-4">
            <span className="me-2">{ICONS.calendarToday()}</span> June 25th, 2026
            <span className="ms-3 me-2">{ICONS.accessTime()}</span> 1:00 PM - 2:00 PM ET
          </div>
          <div className="mb-4">
            <span className="me-2">{ICONS.locationOutlined()}</span> Online
          </div>
        </>,
      additionalInfoMobile:
        <>
          <div className="mb-4">
            <span className="me-2">{ICONS.calendarToday()}</span> June 25th, 2026
          </div>
          <div className="mb-4">
            <span className="me-2">{ICONS.accessTime()}</span> 1:00 PM - 2:00 PM ET
          </div>
          <div className="mb-4">
            <span className="me-2">{ICONS.locationOutlined()}</span> Online
          </div>
        </>
    },
    {
      isMultiple: true,
      type: "EVENT",
      icon: ICONS.calendarToday(),
      postedDate: "Posted MAY 22, 2025",
      eventEndDate: "07-10-2025",
      registrationEndDate: null,
      registrationCloseInfo: null,
      isRegistration: false,
      title: "FHIR Workgroup Meeting",
      desc: "Members of the FHIR Workgroup will be meeting to discuss API Developments, Pilot Updates and other FHIR related topics.",
      additionalInfo:
        <>
          <div className="mb-4">
            <span className="me-2">{ICONS.calendarToday()}</span> July 10th, 2025
            <span className="ms-3 me-2">{ICONS.accessTime()}</span> 11:00 AM - 11:50 AM ET
          </div>
          <div className="mb-4">
            <span className="me-2">{ICONS.locationOutlined()}</span> Online
          </div>
        </>,
      additionalInfoMobile:
        <>
          <div className="mb-4">
            <span className="me-2">{ICONS.calendarToday()}</span> July 10th, 2025
          </div>
          <div className="mb-4">
            <span className="me-2">{ICONS.accessTime()}</span> 11:00 PM - 11:50 PM ET
          </div>
          <div className="mb-4">
            <span className="me-2">{ICONS.locationOutlined()}</span> Online
          </div>
        </>
    }
  ],
]